export default {
  title: {
    notFound: 'No encontrada',
    error: 'Error',
    legal: 'Legal',
    identityConcession: 'Identificación concesión',
    actData: 'Datos del conductor',
    okData: 'Datos guardados correctamente',
    identityDriver: 'Identificación conductor',
    signDriverData: 'Revise sus datos',
    signDriverCompleted: 'Acta de devolución firmada'
  },
  message: {
    generic: {
      loadingData: 'Cargando datos',
      loadingDocuments: 'Cargando documentos'
    },
    warning: {
      checkMessageAllRequired: 'Debe seleccionar según corresponda cada una de las opciones',
      allChecksRequired: 'Todas las opciones deben estar marcadas'
    }
  },
  language: {
    en: 'Inglés',
    es: 'Español'
  },
  ui: {
    button: {
      btnBack: 'Volver',
      btnSave: 'Guardar',
      btnCancel: 'Cancelar',
      btnAccept: 'Aceptar',
      btnClose: 'Cerrar',
      btnCreate: 'Crear',
      btnConfirm: 'Confirmar',
      btnChange: 'Cambiar',
      btnDelete: 'Eliminar',
      btnRecord: 'Grabar',
      btnClear: 'Limpiar',
      btnAcceptAndContinue: 'Aceptar y continuar',
      btnAddAttorney: 'Añadir nuevo apoderado',
      btnRemoveAttorney: 'Quitar apoderado',
      btnSign: 'Enviar a la firma',
      btnYes: 'Si',
      btnNo: 'No',
      btnValidating: 'Validando...',
      btnCancelPickup: 'Cancelar la devolución',
      btnDriverGuide: 'Guía del conductor'
    },
    label: {
      step1: 'Identificación',
      accordionIdentity: 'Confirma tu identidad',
      allDataRequired: 'Todos los datos son obligatorios'
    },
    placeholder: {
      cifDniConcession: 'DNI/CIF',
      zipCode: 'Código postal',
      vehicleId: 'Matrícula',
      vin: 'Bastidor (vale con los últimos 5 dígitos)',
      customerData: 'Datos del cliente',
      receiverData: 'Datos de la persona que recoge el vehículo',
      lessee: 'Arrendatario',
      cifnif: 'CIF/NIF',
      numContract: 'Contrato Arrendatario Num',
      driverData: 'Datos de la persona que devuelve el vehículo',
      name: 'Nombre',
      nameComplete: 'Nombre y apellidos',
      lastname: 'Primer apellido',
      lastname2: 'Segundo apellido',
      dni: 'DNI',
      drivingLicenseDueDate: 'Fecha Exp. Permiso Conducir',
      version: 'Versión',
      carData: 'Datos del vehículo',
      brand: 'Marca',
      modelName: 'Modelo',
      currentKilometers: 'KM. Iniciales',
      kmCount: 'Lectura del cuenta km del vehículo',
      colorName: 'Color',
      engineType: 'Combustible',
      transmission: 'Cambio',
      deliveryCity: 'Lugar de Entrega',
      documentationDeliveredData: 'Documentación Recogida',
      equipmentDeliveredData: 'Equipamiento Entregado',
      accessoriesData: 'Accesorios',
      genre: 'Género',
      profession: 'Ocupación',
      birthDate: 'Fecha de nacimiento',
      maritalStatus: 'Estado Civil',
      email: 'Email',
      mobilePhone: 'Móvil',
      streetType: 'Tipo de vía',
      address: 'Dirección',
      postCode: 'Código postal',
      town: 'Localidad',
      documentTypes: 'Tipo de documento',
      documentId: 'Número de documento (DNI, NIE)',
      documentIdPass: 'DNI/NIE/Pasaporte',
      businessName: 'Razón social',
      cif: 'CIF',
      companyData: 'Datos de la empresa',
      contactData: 'Datos de contacto',
      attorneyData: 'Datos apoderado',
      documentsData: 'Documentos',
      companyName: 'Nombre (Razón Social)',
      constitutionDate: 'Fecha de constitución',
      fax: 'Fax',
      registeredOffice: 'Domicilio Social',
      signType: 'Tipo de firma',
      phone: 'Teléfono',
      selectFile: 'Seleccione un fichero',
      comments: 'Comentarios en el acta',
      providerComment: 'Comentarios en el acta',
      driverProviderComment: 'Comentarios en el acta - Concesión',
      driverDriverComment: 'Comentarios en el acta - Conductor',
      cancelModalTitle: 'Cancelar acta',
      loadingModalTitle: 'Procesando...',
      cancelModalText: '¿Está seguro que quiere cancelar el acta?',
      cancelModalInputLabel: 'Introduzca el motivo de la cancelación',
      documentInvalid: 'Documentos inválidos.',
      checksMessageModalTitle: 'Guardar',
      checksMessageModalText:
        'Hay accesorios sin marcar, pero si desea seguir adelante pulse en el botón Aceptar. Además recuerde que nos puede dejar un comentario para que podamos comunicarnos con el conductor',
      dataSavedOk: 'Los datos se han guardado correctamente',
      errorValidationProcess: 'Error en el proceso de validación.',
      advice: '¡Aviso importante!',
      errorIdentityDefault:
        'Con los datos que nos has proporcionado no existe ningún conductor activo. Si lo deseas, entra en contacto con nosotros. Gracias.',
      errorConcessionsDefault:
        'Con los datos que nos has proporcionado no existen concesiones activas. Si lo deseas, entra en contacto con nosotros. Gracias.',
      errorGetConcessionsDefault:
        'Error inesperado, puede intentarlo más tarde o ponerse en contacto con nosotros para mas información.',
      actSigned: 'Acta firmada',
      signLoadingText:
        'Su firma está siendo procesada. Por favor, no cierre el navegador, podría tardar varios segundos.',
      showFilesModal: {
        title: 'Documentos subidos',
        error: 'Error al cargar los documentos'
      },
      showFiles: 'Ver documentos'
    }
  }
};
